export const CATERING_PATH = '/order-catering';
export const FOUNDATION_PATH = 'https://firehousesubsfoundation.ca/';
export const CAREERS_PATH = 'https://careers.firehousesubs.ca/';
export const FRANCHISE_PATH = 'https://www.franchising.firehousesubs.com/';
export const DONATE_PATH =
  'https://www.canadahelps.org/en/charities/firehouse-subs-public-safety-foundation-of-canada/';
